import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import API from "../../../../app/api";

export const useCancelOrder = (orderNo, items, navigate) => {

    const [reason, setReason] = useState("");
    const [reasonList, setReasonList] = useState([]);
    const [comments, setComments] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchReasons();

        if (!items.length) {
            navigate("/accounts/orders", { replace: true });
        }

    }, []);

    const fetchReasons = async () => {
        try {
            const { data } = await API.get("/reasons/cancellation");
            if (data?.status === 200) {
                setReasonList(data.data);
            }
        } catch {
            setReasonList([]);
        }
    };

    const submitCancel = async () => {

        if (!reason) {
            toast.error("Please select cancellation reason");
            return;
        }

        if (comments.trim().length < 5) {
            toast.error("Comments should be at least 5 characters");
            return;
        }

        setLoading(true);

        try {

            const payload = {
                item_ids: items.map(i => i.id),
                reason_id: Number(reason),
                remarks: comments.trim()
            };

            const { data } = await API.put(`/orders/${orderNo}/cancel`, payload);

            if (data?.success) {
                toast.success("Order cancelled successfully");

                navigate(`/accounts/orders/${orderNo}`, {
                    replace: true,
                    state: { cancelled: true }
                });

            } else {
                toast.error(data?.message || "Cancel failed");
            }

        } catch {
            toast.error("Cancel failed");
        } finally {
            setLoading(false);
        }
    };

    return {
        reason,
        setReason,
        reasonList,
        comments,
        setComments,
        loading,
        submitCancel
    };
};